import { Structure } from "@docma-mm-core/structure/structure";
import { Plan, PlanData } from '@docma-mm-core/plan/plan';


export function sortPlans(structureList: Structure[], planList: Plan[]): Plan[] {
  let sortedPlans = [];

  structureList.forEach(struct => {
    const plans = planList.filter(plan => plan.data.Structure.Id === struct.Id);
    addPlanStructurePath(plans, struct);
    sortedPlans = [...sortedPlans, ...plans];
  })

  return sortedPlans;
}

export function addPlanStructurePath(planList: Plan[], struct: Structure) {
  planList.forEach(plan => plan.data.StructurePath = struct.StructurePath);
}

export function getChildPlansOfStructure(selectedStructure: Structure, planList: Plan[]): Plan[] {
  let structures = [];
  if(selectedStructure.getFlatSortedStructures) {
    structures = selectedStructure.getFlatSortedStructures();
  }
  let childPlans = [];
  structures.forEach(struct => {
    const plans = planList.filter(plan => plan.data.Structure.Id === struct.Id);
    childPlans = [...childPlans, ...plans];
  });

  return childPlans;
}


export function getParentPlansOfStructure(selectedStructure: Structure, treeStructure: Structure, planList: Plan[]): Plan[] {
  const parentPlans: Plan[] = [];

  do {
    selectedStructure = new Structure(treeStructure).findById(selectedStructure?.Parent?.Id);

    planList.filter((plan) => {
      if (plan.data.Structure.Id  === selectedStructure?.Id) {
        parentPlans.push(plan);
      }
    });
  } while (parentPlans.length === 0 && selectedStructure?.Id !== selectedStructure?.RootId);

  return parentPlans;
}

export function convertBpToMmPlan(bpPlan: any, structuresByUid, project): PlanData {

  if(!bpPlan.activeVersion) bpPlan.activeVersion = bpPlan.currentVersion;

  let structureId: number;
  if (isNaN(+bpPlan.structureId) && structuresByUid.hasOwnProperty(bpPlan.structureId)) {
    structureId = structuresByUid[bpPlan.structureId].Id
  } else if (isNaN(+bpPlan.structureId) && bpPlan.structureId == project.MyDocmaUid) {
    structureId = project.Structure.Id;
  } else {
    structureId = +bpPlan.structureId;
  }

  return ({
    Id: bpPlan.id,
    Description: bpPlan.description,
    Structure: {
      Id: structureId,
      StructurePath: bpPlan.structurePath
    },
    FileName: bpPlan.activeVersion?.filename,
    BpPlan: bpPlan
  } as PlanData);
}
